export const RESET = 'CLIENT_UPDATE_RESET'
export const SET_ERROR = 'CLIENT_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'CLIENT_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'CLIENT_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'CLIENT_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'CLIENT_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'CLIENT_UPDATE_UPDATE_RETRIEVED'



// WEBPACK FOOTER //
// ./src/store/modules/client/update/mutation_types.js